import React from 'react';
import { RangerInput, Form } from './../../controls';

const AnnualSavingControl = ({ onChange, data = {} }) => {
	return (
		<Form.Row style={{ marginTop: '1em' }} >
			<Form.LabelDescription>
				<p>Use the slider below to see how a % reduction in absenteeism would directly influence your costs</p>
			</Form.LabelDescription>
			<RangerInput
				min={1}
				max={100}
				width={60}
				suffix='%'
				value={data.totalCostPerDay}
				onChange={value => (onChange(value, 'totalCostPerDay'))}
			/>
		</Form.Row>
	);
};

export default AnnualSavingControl;



// WEBPACK FOOTER //
// ./src/html/components/Calculator/AnnualSavingControl.js